(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dixa-chat"] && !Shopify.designMode) return;
  try {
    
  /** Sync iframe/toggler position once Dixa accepts commands (init is asynchronous). */
  function installDixaApiReadyLayoutSync() {
    if (window.__dixaApiReadyLayoutSyncInstalled || !window._dixa_ || typeof window._dixa_.addListener !== 'function') {
      return;
    }

    window.__dixaApiReadyLayoutSyncInstalled = true;

    window._dixa_.addListener('on-api-ready', () => {
      window.__dixaWidgetState = window.__dixaWidgetState || {};
      window.__dixaWidgetState.apiReady = true;

      document.querySelectorAll('dixa-chat-section').forEach((node) => {
        if (typeof node.applyWidgetLayoutFromDataset === 'function') {
          node.applyWidgetLayoutFromDataset();
        }
      });
    });
  }

  class DixaChatSection extends HTMLElement {
    static get observedAttributes() {
      return ['data-position', 'data-horizontal-padding', 'data-vertical-padding'];
    }

    connectedCallback() {
      this.customTrigger = this.querySelector('[data-dixa-custom-trigger]');
      this.handleTriggerClick = this.handleTriggerClick.bind(this);

      if (this.customTrigger) {
        this.customTrigger.addEventListener('click', this.handleTriggerClick);
      }

      queueMicrotask(() => this.initializeWidget());
    }

    disconnectedCallback() {
      if (this.customTrigger) {
        this.customTrigger.removeEventListener('click', this.handleTriggerClick);
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === newValue) {
        return;
      }

      if (!window.__dixaWidgetState || !window.__dixaWidgetState.apiReady) {
        return;
      }

      if (!this.dataset.messengerToken) {
        return;
      }

      this.ensureDixaApi();
      installDixaApiReadyLayoutSync();
      this.loadBootstrap().then(() => {
        this.applyWidgetLayoutFromDataset();
      }).catch(() => {
        window.__dixaBootstrapPromise = null;
      });
    }

    handleTriggerClick() {
      if (!window._dixa_ || typeof window._dixa_.invoke !== 'function') {
        return;
      }

      window._dixa_.invoke('setWidgetOpen', true);
    }

    initializeWidget() {
      const messengerToken = this.dataset.messengerToken;
      if (!messengerToken) {
        return;
      }

      this.ensureDixaApi();
      installDixaApiReadyLayoutSync();
      this.loadBootstrap().then(() => {
        const payload = this.getInitPayload();
        const state = window.__dixaWidgetState || {};

        if (!state.initInvoked) {
          window._dixa_.invoke('init', payload);
          window.__dixaWidgetState = {
            ...state,
            initInvoked: true,
          };

          /* Fallback if on-api-ready is missed (listener timing); keeps offsets reliable */
          if (!window.__dixaLayoutFallbackTimer) {
            window.__dixaLayoutFallbackTimer = window.setTimeout(() => {
              window.__dixaLayoutFallbackTimer = null;
              window.__dixaWidgetState = window.__dixaWidgetState || {};
              window.__dixaWidgetState.apiReady = true;

              document.querySelectorAll('dixa-chat-section').forEach((node) => {
                if (typeof node.applyWidgetLayoutFromDataset === 'function') {
                  node.applyWidgetLayoutFromDataset();
                }
              });
            }, 750);
          }

          return;
        }

        if (state.apiReady) {
          this.applyWidgetLayoutFromDataset();
        }
      }).catch(() => {
        window.__dixaBootstrapPromise = null;
      });
    }

    applyWidgetLayoutFromDataset() {
      this.applyWidgetLayout(this.getPositionPayload());
    }

    getPositionPayload() {
      const horizontalRaw = Number(this.dataset.horizontalPadding || 0);
      const verticalRaw = Number(this.dataset.verticalPadding || 0);

      return {
        position: this.dataset.position || 'bottomRight',
        horizontalPadding: Number.isFinite(horizontalRaw) ? Math.max(0, Math.round(horizontalRaw)) : 0,
        verticalPadding: Number.isFinite(verticalRaw) ? Math.max(0, Math.round(verticalRaw)) : 0,
      };
    }

    applyWidgetLayout(layout) {
      if (!window._dixa_ || typeof window._dixa_.invoke !== 'function') {
        return;
      }

      window._dixa_.invoke('setPosition', layout);

      /* Some builds apply layout after the next frame; repeat once to avoid stale iframe coords */
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          window._dixa_.invoke('setPosition', layout);
        });
      });
    }

    ensureDixaApi() {
      if (window._dixa_) {
        installDixaApiReadyLayoutSync();
        return;
      }

      window._dixa_ = {
        invoke(method, payload) {
          window._dixa_.pendingCalls = window._dixa_.pendingCalls || [];
          window._dixa_.pendingCalls.push([method, payload]);
        },
        addListener(eventName, listener) {
          window._dixa_.pendingAddListenerCalls = window._dixa_.pendingAddListenerCalls || [];
          window._dixa_.pendingAddListenerCalls.push([eventName, listener]);
        },
      };

      installDixaApiReadyLayoutSync();
    }

    loadBootstrap() {
      if (window.__dixaBootstrapPromise) {
        return window.__dixaBootstrapPromise;
      }

      window.__dixaBootstrapPromise = new Promise((resolve, reject) => {
        /* Dixa bootstrap is global: one tag in document.head, not scoped to this custom element. */
        const existingScript = document.head.querySelector('script[data-dixa-bootstrap]');
        if (existingScript) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = 'https://messenger.dixa.io/bootstrap.js';
        script.setAttribute('charset', 'utf-8');
        script.setAttribute('data-dixa-bootstrap', 'true');
        script.addEventListener('load', () => resolve());
        script.addEventListener('error', () => reject(new Error('Dixa bootstrap failed to load')));

        document.head.appendChild(script);
      });

      return window.__dixaBootstrapPromise;
    }

    getInitPayload() {
      const layout = this.getPositionPayload();
      const hideToggler = this.dataset.hideToggler === 'true';
      const showWidgetCloseButton = this.dataset.showWidgetCloseButton === 'true';

      return {
        messengerToken: this.dataset.messengerToken,
        hideToggler,
        showWidgetCloseButton,
        position: layout.position,
        horizontalPadding: layout.horizontalPadding,
        verticalPadding: layout.verticalPadding,
      };
    }
  }

  if (!customElements.get('dixa-chat-section')) {
    customElements.define('dixa-chat-section', DixaChatSection);
  }

  } catch(e) { console.error(e); }
})();
})();
